var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "assessment_main" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.productFlag == 3
      ? _c("ul", [
          _vm.isStudent || _vm.$_has("zledu.gxzx.zhsxappgz:mgy")
            ? _c(
                "li",
                [
                  _c("img", {
                    staticClass: "app_logo",
                    attrs: { src: require("../img/mgy-logo.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "app_bg",
                    attrs: { src: require("../img/mgy-bg.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.entrySys("mgy")
                        }
                      }
                    },
                    [_vm._v("进入系统")]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.productFlag == 4
      ? _c("ul", [
          _vm.isStudent || _vm.$_has("zledu.gxzx.zsrwappgz:mgy")
            ? _c(
                "li",
                [
                  _c("img", {
                    staticClass: "app_logo",
                    attrs: { src: require("../img/mgy-logo.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "app_bg",
                    attrs: { src: require("../img/mgy-bg.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.entrySys("mgy")
                        }
                      }
                    },
                    [_vm._v("进入系统")]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "assessment_title" }, [
      _c("h2", [_vm._v("智能估值")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73d9689c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73d9689c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/appCenter/components/valuation.vue
// module id = null
// module chunks = 